import { render, staticRenderFns } from "./SideResume.vue?vue&type=template&id=03d915ce&scoped=true&"
import script from "./SideResume.vue?vue&type=script&lang=js&"
export * from "./SideResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d915ce",
  null
  
)

export default component.exports